export const ga4TrackingOfferEvent = async (ga4PerkEvent) => {
  if (ga4PerkEvent === undefined) {
    return;
  }
  const clickOfferEvent = new CustomEvent("offers_tracking", {
    bubbles: false,
    cancelable: false,
    detail: ga4PerkEvent,
  });
  document.dispatchEvent(clickOfferEvent);
};

export const ga4GenericClickEvent = async (ga4Event, componentType) => {
  if (ga4Event === undefined) {
    return;
  }
  ga4Event.componentType = componentType;
  const genericClickEvent = new CustomEvent("click_tracking", {
    bubbles: false,
    cancelable: false,
    detail: ga4Event,
  });
  document.dispatchEvent(genericClickEvent);
}
